/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import trans from '../mixins/trans';
export default {

    mixins: [
        trans
    ],

    data() {

        return {
            passwordPoliy:String,
            min_chars_nbr: 0,
            minUpperNumber: 0,
            min_lower_nbr: 0,
            min_numbr_nbr: 0,
            min_extra_nbr: 0,
            messages: {},
            initialized: false,
            password_policy: ''
        }

    },
    methods: {

        checkPasswordValidity(password,passwordPolicyRegexp) {
            if(!this.initialized) {

                this.initialize(passwordPolicyRegexp);
                this.initialized = true;
            }
            var error_messages = this.passes(password);

            return error_messages;
        },
        retrieveMinCharsNbr() {

            // '.{6,255}$'

            let result = this.password_policy.match(/\.\{(\d+),255\}\$/);
            if (result) {
                this.min_chars_nbr  = result[1];
            }
        },
        retrieveMinUpperNbr() {

            let result = this.password_policy.match(/\(\?=\(\?:\[\^A-Z\]\*\[A-Z\]\)\{(\d+),100\}\)/);
            if (result) {
                this.min_upper_nbr = result[1];
            }
        },
        retrieveMinLowerNbr() {

            let result = this.password_policy.match(/\(\?=\(\?:\[\^a-z\]\*\[a-z\]\)\{(\d+),100\}\)/);
            if (result) {
                this.min_lower_nbr = result[1];
            }
        },
        retrieveMinNumbrNbr() {

            let result = this.password_policy.match(/\(\?=\(\?:\[\^0-9\]\*\[0-9\]\)\{(\d+),100\}\)/);
            if (result) {
                this.min_numbr_nbr = result[1];
            }
        },
        retrieveMinExtraNbr() {

            let result = this.password_policy.match(/\(\?=\(\?:\[a-zA-Z0-9\]\*\[\^a-zA-Z0-9\]\)\{(\d+),100\}\)/);
            if (result) {
                this.min_extra_nbr = result[1];
            }
        },
        passes(password) {

            let regExps = {};
            if (this.min_upper_nbr > 0) {
                regExps['(?=(?:[^A-Z]*[A-Z]){' + this.min_upper_nbr + ',100})'] = this.messages['min_upper_nbr'];
            }

            if (this.min_lower_nbr > 0) {
                regExps['(?=(?:[^a-z]*[a-z]){' + this.min_lower_nbr + ',100})'] = this.messages['min_lower_nbr'];
            }

            if (this.min_numbr_nbr > 0) {
                regExps['(?=(?:[^0-9]*[0-9]){' + this.min_numbr_nbr + ',100})'] = this.messages['min_numbr_nbr'];
            }

            if (this.min_extra_nbr > 0) {
                regExps['(?=(?:[a-zA-Z0-9]*[^a-zA-Z0-9]){' + this.min_extra_nbr + ',100})'] = this.messages['min_extra_nbr'];
            }

            if (this.min_chars_nbr > 0) {
                regExps['.{' + this.min_chars_nbr + ',255}$'] = this.messages['min_chars_nbr'];
            }



            let error_messages = [];
            for (let regex in regExps) {
                if (!password.match(regex)) {
                    error_messages.push(regExps[regex]);
                }
            }

            return error_messages;
        },
        initialize(passwordPolicyRegexp) {


            this.password_policy = passwordPolicyRegexp;

            this.retrieveMinCharsNbr();
            this.retrieveMinUpperNbr();
            this.retrieveMinLowerNbr()
            this.retrieveMinNumbrNbr();
            this.retrieveMinExtraNbr();
            this.messages = {

                'min_upper_nbr': this.__('validation.min_upper_nbr', {'number': this.min_upper_nbr}),
                'min_lower_nbr': this.__('validation.min_lower_nbr', {'number': this.min_lower_nbr}),
                'min_numbr_nbr': this.__('validation.min_numbr_nbr', {'number': this.min_numbr_nbr}),
                'min_extra_nbr': this.__('validation.min_extra_nbr', {'number': this.min_extra_nbr}),
                'min_chars_nbr': this.__('validation.min_chars_nbr', {'number': this.min_chars_nbr})

            };

        },
        getMessages() {
            return this.messages;
        },
        getRestrictions()
        {

            let restrictions = [];
            if (this.min_upper_nbr > 0) {
                restrictions.push(this.messages['min_upper_nbr']);
            }

            if (this.min_lower_nbr > 0) {
                restrictions.push(this.messages['min_lower_nbr']);
            }

            if (this.min_numbr_nbr > 0) {
                restrictions.push(this.messages['min_numbr_nbr']);
            }

            if (this.min_extra_nbr > 0) {
                restrictions.push(this.messages['min_extra_nbr']);
            }

            if (this.min_chars_nbr > 0) {
                restrictions.push(this.messages['min_chars_nbr']);
            }

            return restrictions;
        }
    },
};
